import { render } from "./DrillGridDialog.vue?vue&type=template&id=005b8eb2"
import script from "./DrillGridDialog.vue?vue&type=script&lang=js"
export * from "./DrillGridDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__